'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:RegisterCtrl
 * @description
 * # RegisterCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('RegisterCtrl', function (UserService, FlashService, $location) {
    this.awesomeThings = [
      'HTML5 Boilerplate',
      'AngularJS',
      'Karma'
    ];

    var vm = this;

    function register() {
      vm.dataLoading = true;
      UserService.Create(vm.user)
        .then(function (response) {
          if (response.success) {
            FlashService.Success('Registration successful', true);
            vm.dataLoading = false;
            $location.path('/login');
          } else {
            FlashService.Error(response.message, false);
            vm.dataLoading = false;
          }
        });
    }

    vm.register = register;
  });
